import { AuthUserData, UserRole } from '../models/user';

export default function isAllowed(user: AuthUserData, requiredPermissions: UserRole[] | UserRole, businessId: string) {
  if (user.type === 'ROOT') {
    return true;
  }

  return user.user_businesses.some((ub) => requiredPermissions.includes(ub.permissions) && ub.active && ub.business_id === businessId);
}
